<template>
  <div>
    <AudioToolLoading v-if="state === 'loading'" />
    <div v-else class="max-w-lg w-full mx-auto">
      <div class="text-center w-full h-auto">
        <p class="text-base text-red-500">
          {{ error }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Auth from "../../../api/auth";
import AudioToolLoading from "./AudioToolLoading.vue";

export default {
  name: "AudioTool",
  props: {
    organiser: Object,
  },
  data: function () {
    return {
      state: "loading",
      error: "",
    };
  },
  methods: {
    redirectToCombinedEditor(clip) {
      this.$router.replace({
        path: `/submission/${clip.registration.id}`,
        query: {
          uni: this.organiser.slug,
          timecode: clip.submission.in_point,
          initial_in: clip.submission.in_point,
          initial_out: clip.submission.out_point,
          source_submission: this.$route.params.id,
        },
      });
    },
  },
  beforeCreate() {
    const clipId = this.$route.params.id;
    axios
      .get(`/clips/${clipId}`, {
        headers: {
          Authorization: "Bearer " + Auth.getPublicRequestToken(),
        },
      })
      .then((response) => response.data)
      .then((clipData) => this.redirectToCombinedEditor(clipData))
      .catch((error) => {
        this.state = "error";
        this.error =
          error?.response?.data?.error ||
          "We could not load the clip editor. Please try again.";
      });
  },

  components: {
    AudioToolLoading,
  },
};
</script>
